module.exports = __webpack_public_path__ + "img/SysComm5.85876986.png";